import axios from "axios";
import Cookies from "js-cookie";

// L-01 (MA-06): auth now travels via an httpOnly cookie, not a Bearer header built
// from a localStorage-readable token. Mutating requests still need the CSRF header,
// read from the matching non-httpOnly csrf cookie.
//
// Cookie split: this app's session lives in `mantis_business_session` (not
// `mantis_session` — Admin's cookie), so its CSRF cookie is `businessCsrfToken`, and
// every request carries `X-Mantis-App: business` so the backend knows which cookie
// pair to read — both pairs share Domain=mantisapp.co and the browser sends both once
// a user is logged into both apps.
const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

const axiosWithAuth = axios.create({ withCredentials: true });

axiosWithAuth.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  config.headers = config.headers || {};
  config.headers["X-Mantis-App"] = "business";
  if (MUTATING_METHODS.has(method)) {
    const csrfToken = Cookies.get("businessCsrfToken");
    if (csrfToken) {
      for (const key of Object.keys(config.headers)) {
        if (key.toLowerCase() === "x-csrf-token") {
          delete config.headers[key];
        }
      }
      config.headers["X-CSRF-Token"] = csrfToken;
    }
  }
  return config;
});

export default axiosWithAuth;
